import type { CellCoordsObj, CellSelection, CellSelections } from '../../../../../../common/table/TableTypes';

/**
 * Returns the start row index from a cell selection tuple.
 */
export const getStartRow = (cellSelection: CellSelection): number => cellSelection[0];
/**
 * Returns the start column index from a cell selection tuple.
 */
export const getStartCol = (cellSelection: CellSelection): number => cellSelection[1];
/**
 * Returns the end row index from a cell selection tuple.
 */
export const getEndRow = (cellSelection: CellSelection): number => cellSelection[2];
/**
 * Returns the end column index from a cell selection tuple.
 */
export const getEndCol = (cellSelection: CellSelection): number => cellSelection[3];

/**
 * Returns the starting cell coordinates for a selection.
 */
export const getStartSelectionCoords = (cellSelection: CellSelection): CellCoordsObj => ({
    row: getStartRow(cellSelection),
    col: getStartCol(cellSelection),
});

/**
 * Returns the ending cell coordinates for a selection.
 */
export const getEndSelectionCoords = (cellSelection: CellSelection): CellCoordsObj => ({
    row: getEndRow(cellSelection),
    col: getEndCol(cellSelection),
});

/**
 * Returns the selection at the requested layer, if it exists.
 */
export const getCellSelectionInLayer = (cellSelections: CellSelections, layer: number): CellSelection | undefined =>
    cellSelections?.[layer];

/**
 * Returns the first selection from a selection list, if present.
 */
export const getFirstSelection = (cellSelections: CellSelections | undefined): CellSelection | undefined =>
    cellSelections?.[0];

/**
 * Returns the start coordinates of the first selection.
 */
export const getFirstSelectionStartCellCoords = (cellSelections: CellSelections): CellCoordsObj => {
    const firstCellSelection = getFirstSelection(cellSelections) as CellSelection;

    return {
        row: getStartRow(firstCellSelection),
        col: getStartCol(firstCellSelection),
    };
};
